"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Card_1 = __importDefault(require("./Card"));
const CardContainer_1 = __importDefault(require("./CardContainer"));
const Text_1 = __importDefault(require("./Text"));
const ChevronLeftIcon_1 = __importDefault(require("../icons/ChevronLeftIcon"));
const ExpandbleCard = ({ title, titleColor = 'default', chevronColor = 'primary', children, getState, style, }) => {
    const [expanded, setExpanded] = react_1.useState(false);
    return (react_1.default.createElement(Card_1.default, { style: style },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                setExpanded(!expanded);
                if (getState) {
                    getState(expanded);
                }
            } },
            react_1.default.createElement(CardContainer_1.default, null,
                react_1.default.createElement(react_native_1.View, { style: styles.centerRow },
                    react_1.default.createElement(Text_1.default, { variant: "mediumBody", margin: "none", color: titleColor }, title),
                    react_1.default.createElement(react_native_1.View, { style: { transform: [{ rotate: expanded ? '90deg' : '-90deg' }], marginBottom: 4 } },
                        react_1.default.createElement(ChevronLeftIcon_1.default, { stroke: styles_1.Colors[chevronColor] }))),
                expanded && react_1.default.createElement(react_native_1.View, { style: styles.childrenView }, children)))));
};
exports.default = ExpandbleCard;
const styles = react_native_1.StyleSheet.create({
    centerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    childrenView: {
        borderTopColor: styles_1.Colors.lightgrey,
        borderTopWidth: 2,
        paddingTop: styles_1.getSpacing(),
        marginTop: styles_1.getSpacing(),
    },
});
